import React from "react";
import {
  Home,
  Users,
  Globe,
  Radio,
  User,
  FileText,
  Search,
  Edit3,
  MessageCircle,
  Send,
  Bookmark,
  BookmarkCheck ,
  Play,
  CheckCircle,
  MoreVertical,
  Plus,
  Heart,
  Shield,
  ChevronRight,
  Sun,
  BookOpen,
  Handshake,
  Trophy,
  Sparkles,
  Layers,
  Tv,
  UserCircle,
  Image,
  LogOut,
} from "lucide-react";

const iconMap = {
  home: Home,
  community: Users,
  globe: Globe,
  stream: Radio,
  profile: User,
  about: FileText,
  search: Search,
  bookmarkOff:BookmarkCheck,
  edit: Edit3,
  chat: MessageCircle,
  send: Send,
  bookmark: Bookmark,
  play: Play,
  check: CheckCircle,
  more: MoreVertical,
  plus: Plus,
  heart: Heart,
  shield: Shield,
  users: Users,
  chevronRight: ChevronRight,
  sun: Sun,
  book: BookOpen,
  handshake: Handshake,
  trophy: Trophy,
  sparkle: Sparkles,
  layers: Layers,
  tv: Tv,
  accountCircle: UserCircle,
  image: Image,
  logout: LogOut,
};

const Icon = ({ name, size = 20, className = "", ...props }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return null;
  return <IconComponent size={size} className={className} {...props} />;
};

export default Icon;
